import { feature } from '@/domain/enums/asset';
import { AssetTypes } from 'sigma-mappings';
import RegistrationData from '@/app/installation/assetInformation/common/registrationData';
import BaseGeneralData from '@/app/installation/assetInformation/common/BaseGeneralData';
import Files from '@/app/installation/assetInformation/common/Files';
import TransformersGeneralData from '@/app/installation/assetInformation/transformers/generalData';
import TransformersLosses from '@/app/installation/assetInformation/transformers/losses/index';
import TransformersCoolingStages from '@/app/installation/assetInformation/transformers/coolingStages/CoolingStages';
import DisconnectorsGeneralData from '@/app/installation/assetInformation/disconnectors/GeneralData';
import CircuitBreakersGeneralData from '@/app/installation/assetInformation/circuitBreakers/GeneralData';

/**
 * Definição de components para cada feature/tela de informações do ativo
 */
export default {
  [feature.REGISTRATION_DATA]: RegistrationData,
  [feature.GENERAL_DATA]: BaseGeneralData,
  [feature.LOSSES]: TransformersLosses,
  [feature.COOLING_STAGES]: TransformersCoolingStages,
  [feature.FILES]: Files,
};

/**
 * Subtipos de components para tela de Dados Gerais
 */
export const generalDataComponents = {
  [AssetTypes.TRANSFORMER]: TransformersGeneralData,
  [AssetTypes.DISCONNECTOR]: DisconnectorsGeneralData,
  [AssetTypes.CIRCUIT_BREAKER]: CircuitBreakersGeneralData,
};
